var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMh = function SvgMh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 570 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003893",
    d: "M0 0h570v300H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 295.2V288L570 35v87.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd7500",
    d: "M0 290.4v-4.8L570 4.8v58.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(109.536 109.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mh_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-93 5.59 0H-5.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mh_svg__a",
    d: "M0-66.588 6.824 0H-6.824z",
    transform: "rotate(15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mh_svg__a",
    transform: "rotate(15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mh_svg__a",
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mh_svg__a",
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mh_svg__a",
    transform: "rotate(60)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mh_svg__b",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mh_svg__b",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mh_svg__b",
    transform: "rotate(270)"
  }))));
};
export default SvgMh;